module.exports = __webpack_public_path__ + "imgs/10da7f8fb943f4c43670e5f776a233c3.jpg";